var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 0.666748C4.41675 0.666748 0.666748 4.41675 0.666748 9.00008C0.666748 13.5834 4.41675 17.3334 9.00008 17.3334C13.5834 17.3334 17.3334 13.5834 17.3334 9.00008C17.3334 4.41675 13.5834 0.666748 9.00008 0.666748ZM10.6667 13.1667L8.16675 8.83342V4.83341H9.41675V8.50008L11.7501 12.5834L10.6667 13.1667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.c0631dba.svg";
export { ForwardRef as ReactComponent };